import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { ReportData } from '../SuitabilityFlow';
import SelectFilesStep from './SelectFilesStep';

type SelectFeeDocumentsStepProps = StepProps<ReportData>;

export default function SelectFeeDocumentsStep(props: SelectFeeDocumentsStepProps) {
  const { data } = props;

  return (
    <SelectFilesStep
      {...props}
      title={`Include fee documentation ${data.client?.firstName ? 'for ' + data.client.firstName : ''}`}
      description="Select any documents that contain fee information to be referenced in the report. This includes provider fee schedules, platform charges, fund costs, and adviser fee agreements."
      hint="Only include documents that contain fee-related information. The fees extracted from these documents will be used to populate fee disclosures in the suitability report."
      selectedFileIds={props.data.selectedFeeDocumentIds}
      setSelectedFileIds={selectedFileIds =>
        props.setData({ ...props.data, selectedFeeDocumentIds: selectedFileIds })
      }
    />
  );
}
